import { ResponsiveFlex } from "@narmi/design_system";
import { NavigationAnchor } from "./navigation/NavigationLink";
import styles from "./QuickLink.module.css";

const QuickLink = ({
  to,
  children,
  isExternal = false,
}: {
  to: string;
  children: React.ReactNode;
  isExternal?: boolean;
}) => (
  <li>
    <NavigationAnchor to={to}>
      <ResponsiveFlex direction="row" gapSize="xs">
        <div>{children}</div>
        {isExternal ? (
          <div className="padding--top--xxxs">
            <i className="narmi-icon-external-link" />
          </div>
        ) : null}
      </ResponsiveFlex>
    </NavigationAnchor>
  </li>
);

export const QuickLinks = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.Quicklinks}>
    <h2>Quicklinks</h2>
    <ul>{children}</ul>
  </div>
);

QuickLinks.Link = QuickLink;
